import TumengMultiImgEdit from './src/index.vue'

TumengMultiImgEdit.install = function(Vue) {
  Vue.component(TumengMultiImgEdit.name, TumengMultiImgEdit)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengMultiImgEdit)
}

export default TumengMultiImgEdit
